var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepBasket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.step-basket-0{fill:none;stroke:#5E5E5E;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.step-basket-1{fill:none;stroke:#5E5E5E;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.step-basket-2{fill:none;stroke:#5E5E5E;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.step-basket-3{fill:none;stroke:#5E5E5E;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "step-basket-3",
    x1: 20.3,
    y1: 7.5,
    x2: 20.1,
    y2: 8.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "step-basket-3",
    points: "0.4,1.9 3.2,1.9 6.3,15.3 19.1,15.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "step-basket-3",
    points: "5.4,11.6 19.1,11.6 19.6,9.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "step-basket-3",
    points: "3.5,3 21.6,3 20.8,5.8  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "step-basket-3",
    cx: 7.2,
    cy: 18.5,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "step-basket-3",
    cx: 17.5,
    cy: 18.5,
    r: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepBasket);
export default __webpack_public_path__ + "static/media/step-basket.976da2f6.svg";
export { ForwardRef as ReactComponent };